<template>
  <div v-if="bringgOrderResponse">
    <section class="order-confirmed__info">
      <div class="order-confirmed__status">
        <p class="order-confirmed__status__title">STATUS</p>
        <p class="order-confirmed__status__stage">{{ bringgOrderResponse.status }}</p>
      </div>
      <div class="order-confirmed__eta">
        <p class="order-confirmed__eta__title">ETA</p>
        <p class="order-confirmed__eta__time">{{ deliveryEta }}</p>
      </div>
    </section>

    <section class="order-confirmed__image-wrapper">
      <status-received class="order-confirmed__image" :orderStep="bringgOrderResponse.orderStep" />
      <ProgressIndicator :currentStage="bringgOrderResponse.orderStep > 1 " />
      <status-preparing :orderStep="bringgOrderResponse.orderStep" />
      <ProgressIndicator :currentStage="bringgOrderResponse.orderStep > 2" />
      <status-delivering :orderStep="bringgOrderResponse.orderStep" />
      <ProgressIndicator :currentStage="bringgOrderResponse.orderStep === 4" />
      <status-complete :orderStep="bringgOrderResponse.orderStep" />
    </section>

  </div>

</template>

<script>
import ProgressIndicator from "@/components/Order/Confirmation/ProgressIndicator.vue";
import StatusComplete from "@/assets/order_status/complete.vue";
import StatusReceived from "@/assets/order_status/received.vue";
import StatusPreparing from "@/assets/order_status/preparing.vue";
import StatusDelivering from "@/assets/order_status/delivering.vue";
import { mapState } from "vuex";


export default {
  name: "confirmedStatusBringg",
  components: { StatusDelivering, StatusPreparing, StatusReceived, StatusComplete, ProgressIndicator },
  computed: {
    ...mapState({
      bringgOrderResponse: state => state.orderStatus.bringgOrderResponse,
      deliveryEta: state => state.orderStatus.deliveryEta
    })
  }
};
</script>

<style lang="scss" scoped>

.order-confirmed {
  &__info {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 3px;

  }

  &__status {
    &__title {
      font-size: 14px;
      font-weight: bold;
      color: #a3a3a3;
      margin-bottom: 0;
    }

    &__stage {
      color: #212121;
      font-size: 16px;
      font-weight: bold;
    }
  }

  &__eta {
    &__title {
      font-size: 14px;
      font-weight: bold;
      color: #a3a3a3;
      margin-bottom: 0;
    }

    &__time {
      color: #212121;
      font-size: 16px;
      font-weight: bold;
    }
  }

  &__image {
    border-radius: 50%;
    height: 44px;
    width: 44px;

    &-wrapper {
      margin-bottom: 24px;
      display: flex;
      align-items: center;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .order-confirmed {
    &__image {
      height: 50px;
      width: 50px;

      &-wrapper {
      }
    }
  }
}

</style>
